<template>
  <div
    :class="isOpen ? $style['item--open'] : $style['item']"
    @click="openDropdown()"
  >
    <div
      :class="isOpen ? [$style['item__row'], $style['item__row--selected']] : $style['item__row']"
      :aria-label="label"
    >
      <Icon
        v-if="icon"
        :name="icon"
        :size="20"
        :fill="isOpen ? 'var(--color-mono-100)' : 'var(--color-primary-700)'"
      />
      <slot name="label">
        <Paragraph4>{{ label }}</Paragraph4>
      </slot>

      <IconArrowDown
        :class="{
          [$style['item__arrow']]: true,
          [$style['item__arrow--open']]: true,
        }"
        :size="10"
        :fill="
          isOpen
            ? 'var(--dropdown-arrow-open, var(--color-mono-100))'
            : 'var(--dropdown-arrow-close, var(--color-primary-700))'
        "
      />
    </div>
    <!-- <nav
      v-if="isMobileNav"
      :class="[$style['item__dropdown-nav'], isOpen ? $style['item__dropdown-nav--open'] : '']"
    >
      <div
        v-if="isOpen"
        :class="$style['item__mega-nav']"
      >
        <slot name="default" />
      </div>
    </nav>
    <nav
      v-else
      :class="[$style['item__dropdown'], isOpen ? $style['item__dropdown--open'] : '']"
    >
      <div>
        <div
          v-if="isOpen"
          :class="$style['item__mega']"
        >
          <slot name="default" />
        </div>
      </div>
    </nav> -->

    <nav
      :class="[
        isMobileNav
          ? isOpen
            ? [$style['item__dropdown-nav'], $style['item__dropdown-nav--open']]
            : $style['item__dropdown-nav']
          : isOpen
            ? [$style['item__dropdown'], $style['item__dropdown--open']]
            : $style['item__dropdown'],
      ]"
    >
      <div
        v-if="isOpen"
        :class="$style['item__mega']"
      >
        <slot name="default" />
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import Icon from '~/components-daisy/icons/Icon.vue';
import Paragraph4 from '~/components-daisy/typography/paragraph-4/Paragraph4.vue';
import IconArrowDown from '~/components-daisy/icons/icons/arrow/IconArrowDown.vue';

type Props = {
  label?: string;
  icon: string;
  isMobileNav: boolean;
  forceClose?: boolean;
};
const props = withDefaults(defineProps<Props>(), {
  label: '',
  forceClose: false,
});

const emits = defineEmits<{
  open: [];
}>();

const isOpen = ref(false);
const openDropdown = () => {
  isOpen.value = !isOpen.value;
  if (isOpen.value) emits('open');
};
onMounted(() => {
  isOpen.value = false;
});

watch(
  () => props.forceClose,
  (forceClose) => {
    if (forceClose) isOpen.value = false;
  }
);
</script>

<style lang="postcss" module>
@keyframes menuSlideIn {
  0% {
    transform: translateY(-10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.item {
  display: flex;
  min-height: 42px;
  align-items: center;

  &__row {
    min-height: 42px;
    display: flex;
    align-items: center;
    justify-content: var(--dropdown-label-justify-content, center);
    cursor: pointer;
    transition: all ease-in-out 250ms;
    gap: var(--space-50);
    background-color: var(--dropdown-background, transparent);
    border-radius: var(--border-radius-200);
    color: var(--dropdown-text-color, var(--color-mono-700));
    padding: var(--dropdown-spacing, var(--space-50));

    &--selected {
      min-height: 42px;
      transition: all ease-in-out 250ms;
      background-color: var(--dropdown-background, var(--color-primary-800));
      color: var(--color-primary-100);

      @media (hover: hover) {
        &:hover {
          color: var(--color-primary-500) !important;
        }
      }
    }

    @media (hover: hover) {
      &:hover {
        color: var(--color-primary-700);
      }
    }
  }

  &__arrow {
    transition: transform ease-in-out 500ms;
    will-change: transform;
    transform: rotate(0deg);
  }

  &--open {
    position: relative;

    .item__arrow {
      transition: transform ease-in-out 500ms;
      will-change: transform;
      transform: rotate(180deg);
    }

    .item__dropdown {
      width: 156px;
      position: absolute;
      bottom: 0;
      flex-direction: column;
      z-index: 11;
      height: 0;
      display: flex;

      &--open {
        opacity: 0;
        animation: menuSlideIn 0.5s ease 0.25s forwards;
      }
    }
  }

  &__dropdown {
    display: none;

    &--open {
      opacity: 0;
      animation: menuSlideIn 0.5s ease 0.25s forwards;
    }
  }

  &__mega {
    display: flex;
    align-items: center;
    /* justify-content: space-around; */
    border-top: 1px solid var(--color-primary-400);
    background: var(--color-mono-100);
    border-radius: var(--border-radius-100);
    box-shadow: var(--shadow-200);
    flex-direction: column;
  }
}

.item__dropdown-nav {
  width: var(--dropdown-nav-width, 156px);
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  z-index: 1;
  height: 0;
  display: block;

  &--open {
    z-index: 40;
    opacity: 0;
    animation: menuSlideIn 0.5s ease 0.25s forwards;
  }
}
</style>
